import useProjectDashboardQuery, {
  projectDashboardPortfolioDataType,
} from "@/api/query/useProjectDashboardQuery";
import PieChart, { ChartProps } from "@/components/charts/PieChart";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import dateFormatter from "@/helperFuntions/dateFormater";
import Sunny from "@/assets/png/SunnyNew.png";
import Cloudy from "@/assets/png/CloudyNew.png";
import Rainy from "@/assets/png/RainyNew.png";
import Stormy from "@/assets/png/StormyNew.png";
import {
  OverAllTrackEnumValue,
  ProjectStatusEnumValue,
  ScheduleAndBudgetTrend,
} from "@backend/src/schemas/enums";
import Increasing from "@/assets/increase.svg";
import Decreasing from "@/assets/decrease.svg";
import Stable from "@/assets/stable.svg";
import LinkArrow from "@/assets/svg/linkArrow.svg";
import {
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import InfoCircle from "@/assets/svg/Info circle.svg";
import dateFormater from "@/helperFuntions/dateFormater";
import Loader from "@/components/common/Loader";
import { useTranslation } from "react-i18next";
import RiskMatrixTable from "@/pages/risk-management/matrix-table";
import { RiskType } from "@/api/mutation/useAddRIskMutation";
import useAllRiskQuery from "@/api/query/useAllRisk";
import PercentageCircle from "@/components/shared/PercentageCircle";
import useAllTaskQuery from "@/api/query/useAllTaskQuery";
interface ColorMapping {
  [key: string]: string;
}
export type ThemeColorData = {
  theme: string;
  colors: {
    tabTexts: string;
    tabGradient: string;
    tabBorders: string;
    mainTexts: string;
    subTexts: string;
    chartColors: string[];
    chartGradient: string;
    chartBorders: string;
    chartHeadingTexts: string;
  };
};
function ProjectDashboard() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState<projectDashboardPortfolioDataType>();
  const [selectedStatusTheme, setSelectedStatusTheme] =
    useState<ThemeColorData>();
  const [statusPieChartProp, setstatusPieChartProp] = useState<ChartProps>();
  const [barChartProp, setBarChartProp] = useState<ChartProps>();
  const projectId = useParams()?.projectId;
  const projectDashboardQuery = useProjectDashboardQuery(projectId);
  const [riskMatrix, setRiskMatrix] = useState<RiskType[]>([]);
  const allRIskQuery = useAllRiskQuery(projectId ?? "");
  const cpiComponent = useRef<HTMLDivElement | null>(null);
  const colorThemeArr: ThemeColorData[] = [
    {
      theme: OverAllTrackEnumValue.SUNNY,
      colors: {
        tabTexts: "text-white",
        tabGradient: "bg-gradient-to-r  from-primary-500 to-primary-300",
        tabBorders: "border-primary-900 ",
        mainTexts: "text-primary-800",
        subTexts: "text-primary-800",
        chartColors: ["#3D348B", "#F7B801", "#F18701"],
        chartGradient: "",
        chartBorders: "border border-gray-500",
        chartHeadingTexts: "#000000",
      },
    },
    {
      theme: OverAllTrackEnumValue.CLOUDY,
      colors: {
        tabTexts: "text-white",
        tabGradient: "bg-gradient-to-r  from-gray-500 to-gray-300",
        tabBorders: "border-gray-900 ",
        mainTexts: "text-gray-500",
        subTexts: "text-gray-800",
        chartColors: ["#FFD04A", "#FFB819", "#B74E06"],
        chartGradient: "bg-gradient-to-r from-gray-400 to-gray-200 ",
        chartBorders: "border border-gray-300",
        chartHeadingTexts: "#000000",
      },
    },
    {
      theme: OverAllTrackEnumValue.RAINY,
      colors: {
        tabTexts: "text-white",
        tabGradient: "bg-gradient-to-r  from-gray-500 to-gray-300",
        tabBorders: "border-cyan-500 ",
        mainTexts: "text-gray-500",
        subTexts: "text-cyan-300",
        chartColors: ["#cffafe", "#6fe9f9", "#06b6d4"],
        chartGradient: "",
        chartBorders: "border border-gray-300",
        chartHeadingTexts: "#000000",
      },
    },
    {
      theme: OverAllTrackEnumValue.STORMY,
      colors: {
        tabTexts: "text-white",
        tabGradient: "bg-gradient-to-r  from-gray-500 to-gray-300",
        tabBorders: "border-cyan-500 ",
        mainTexts: "text-gray-500",
        subTexts: "text-primary-300",
        chartColors: ["#FFD04A", "#7becff", "#06b6d4"],
        chartBorders: "border border-gray-300",
        chartGradient: "",
        chartHeadingTexts: "#000000",
      },
    },
  ];

  useEffect(() => {
    setRiskMatrix(allRIskQuery.data?.data.data ?? []);
  }, [allRIskQuery.data?.data.data]);
  const setTheme = () => {
    // if (data && colorThemeArr) {
    //   const statusThemeData = colorThemeArr.find(
    //     (key) => key?.theme === data?.projectOverAllSituation
    //   );
    // }
    setSelectedStatusTheme(colorThemeArr[0]);
  };

  useEffect(() => {
    projectDashboardQuery?.refetch().then(res=>{
      setData(res.data?.data.data);
      setTheme()
    })
  }, [projectId]);

  useEffect(() => {
    const statusPieChartDatacolors = [
      { IN_PROGRESS: "#4DA8EF" },
      { NOT_STARTED: "#636363" },
      { COMPLETED: "#68B266" },
    ];

    if (selectedStatusTheme) {
      const statusPieChartData = data?.taskStatusChartData?.labels.map(
        (name: string, index) => ({
          value: Number(data?.taskStatusChartData?.data[index]),
          name: t(name),
        })
      );
      const filteredColorsStatusPieChartData = statusPieChartDatacolors.reduce(
        (acc: ColorMapping, curr) => {
          const [key, value] = Object.entries(curr)[0];

          acc[t(key)] = value;
          return acc;
        },
        {} as ColorMapping
      );

      const colors = statusPieChartData
        ?.map((obj) => Object.values(obj)[1])
        .map((weather) => filteredColorsStatusPieChartData[weather]);

      if (statusPieChartData) {
        setstatusPieChartProp({
          chartData: statusPieChartData,
          color: colors ?? [],
          title: t("tasks_by_status"),
          height: "100%",
          radius: ["0%", "70%"],
          hoverText: "Are",
        });
      }
      const delayCounts = {
        red: 0,
        green: 0,
        orange: 0,
      };
      data?.taskDelayChartData?.forEach((task) => {
        if (task.tpiFlag === "Red") {
          delayCounts.red += 1;
        } else if (task.tpiFlag === "Green") {
          delayCounts.green += 1;
        } else if (task.tpiFlag === "Orange") {
          delayCounts.orange += 1;
        }
      });
      const anyDelayExists = Object.values(delayCounts).some(
        (count) => count > 0
      );
      if (anyDelayExists) {
        const chartData: ChartProps["chartData"] = [];
        const keyOfdelayCounts = Object.keys(
          delayCounts
        ) as (keyof typeof delayCounts)[];
        keyOfdelayCounts.forEach((r) => {
          const val = delayCounts[r];
          if (val > 0) {
            switch (r) {
              case "red":
                chartData.push({
                  value: delayCounts.red,
                  name: t("SIGNIFICANT_DELAY"),
                });
                break;
              case "green":
                chartData.push({
                  value: delayCounts.green,
                  name: t("ON_TIME"),
                });
                break;
              case "orange":
                chartData.push({
                  value: delayCounts.orange,
                  name: t("MODERATE_DELAY"),
                });
                break;
            }
          }
        });

        const SpiPiecolors = [
          { SIGNIFICANT_DELAY: "#EA4335" },
          { ON_TIME: "#68B266" },
          { MODERATE_DELAY: "#FFA500" },
        ];

        const spiFilteredColors = SpiPiecolors.filter((e) => {
          const key = Object.keys(e)[0];
          return chartData.some((r) => r.name === t(key));
        }).map((obj) => Object.values(obj)[0]);
        setBarChartProp({
          chartData: chartData,
          color: spiFilteredColors,
          title: t("tasks_by_progression"),
          height: "100%",
          radius: ["0%", "70%"],
          hoverText: "Are",
        });
      } else {
        setBarChartProp({
          chartData: [],
          color: ["#FF000077", "#00800077", "#FFB81977"],
          title: t("tasks_by_progression"),
          height: "100%",
          radius: ["0%", "70%"],
        });
      }
    }
  }, [
    selectedStatusTheme,
    projectDashboardQuery?.data?.data?.data,
    projectId,
    i18n.language,
    data
  ]);

  const navigate = useNavigate();
  const filterRoutes = (item: string) => {
    switch (item) {
      case "Milestones":
        navigate(`/tasks/${projectId}?milestones=true`);
        break;
      case "Tasks":
        navigate(`/tasks/${projectId}`);
        break;
      case "Members":
        navigate(`/members/${projectId}`);
        break;
      default:
        break;
    }
  };
  const getSPI = () => {
    if (data && data.spi) {
      return data.spi?.toFixed(4);
    } else {
      return 0;
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case ProjectStatusEnumValue.NOT_STARTED:
        return "!bg-status-gray text-white";
      case ProjectStatusEnumValue.ON_HOLD:
        return "!bg-status-purple text-white";
      case ProjectStatusEnumValue.ACTIVE:
        return "!bg-status-green text-white";
      case ProjectStatusEnumValue.CLOSED:
        return "!bg-status-black text-white";
    }
  };
  const getOverallHealthColor = (status: string) => {
    switch (status) {
      case OverAllTrackEnumValue.SUNNY:
        return "!bg-[#FBBC05] text-white";
      case OverAllTrackEnumValue.RAINY:
        return "!bg-[#4682B4] text-white";
      case OverAllTrackEnumValue.STORMY:
        return "!bg-[#4B0082] text-white";
      case OverAllTrackEnumValue.CLOUDY:
        return "!bg-[#636363] text-white";
    }
  };
  const open = (data: RiskType) => {
    navigate(`/risk/${projectId}`, {
      state: data,
    });
    window.history.replaceState({}, "");
  };
  const taskQuery = useAllTaskQuery(projectId ?? '',true);
const [color, setColor] = useState("#68B266");

useEffect(() => {
  const tasks = taskQuery.data?.data.data;
  
  if (!tasks || tasks.length === 0) {
    const todayDate = new Date()
    const projectStartDate = new Date(projectDashboardQuery.data?.data.data.projectDates?.startDate ?? "")
    if(projectStartDate < todayDate) {
      setColor("#EA4335")
    }
    return;
  }

  const uniqueFlags = new Set(tasks.map(task => task.flag));

  if (uniqueFlags.size === 1) {
    const onlyFlag = uniqueFlags.values().next().value;
    const flagColorMap: Record<string, string> = {
      Green: "#68B266",
      Red: "#EA4335",
      Orange: "#FFA500", 
    };
    setColor(flagColorMap[onlyFlag as string] ?? "#68B266");
  } else {
    const spi = Number(getSPI());
    const computedColor =
      spi < 80
        ? "#EA4335"
        : spi < 95
          ? "#FFA500"
          : "#68B266";

    setColor(computedColor);
  }
}, [projectDashboardQuery.data?.data.data,data,taskQuery.data?.data.data]);

  
  
  return (
    <>
      {projectDashboardQuery.isRefetching ? (
        <Loader className="absolute top-0 left-0" />
      ) : (
        selectedStatusTheme &&
        data  && projectId&& (
          <>
            <div className="overflow-auto w-full self-center py-8 px-8 flex flex-col gap-3 h-full" key={projectId}>
              <div className=" relative w-full h-fit flex  justify-center items-center   ">
                <div className="w-full h-full flex gap-8 ">
                  <div className="progress w-full  flex flex-col relative justify-center items-center gap-1 py-2 border-2 border-gray-450/50 rounded-xl">
                    <div className="text-base text-gray-450/80 ">
                      {t("project_progress")}
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger className="flex gap-1 items-center absolute top-2 right-2">
                            <img
                              src={InfoCircle}
                              className="h-[16px] w-[16px] brightness-0"
                              alt="InfoCircle"
                            />
                          </TooltipTrigger>
                          <TooltipContent>
                            <p className="text-sm text-center w-96">
                              <div dangerouslySetInnerHTML={{
                                __html: t("project_progress_tooltip"),
                              }}></div>
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    </div>

                    <PercentageCircle percentage={data?.projectProgression  ? Number(data?.projectProgression ) * 100 : 0} className="my-3"
                      roundColor={color} />
                  </div>
                  <div className="flex flex-col gap-1 w-full h-full items-center justify-center text-center border-2 border-gray-450/50 rounded-xl ">
                    <div className="text-base text-gray-450/80 ">
                      {t("project_status")}
                    </div>
                    <div
                      className={`text-4xl font-semibold ${selectedStatusTheme?.colors?.mainTexts}`}
                    >
                      <div
                        className={`w-32 h-8 px-3 py-1.5 ${getStatusColor(
                          data?.projectStatus
                        )} rounded justify-center items-center gap-px inline-flex`}
                      >
                        <div className=" text-xs font-medium leading-tight">
                          {t(data?.projectStatus)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full h-full border-2 border-gray-450/50 rounded-xl relative overflow-hidden ">
                    <div className="flex flex-col gap-1 md:gap-3 w-full h-full text-center text-2xl md:text-3xl font-medium items-center justify-center">
                      <div className="text-base text-gray-450/80 ">
                        {t("project_overall_health")}
                      </div>
                      <div
                        className={`${selectedStatusTheme?.colors?.subTexts} font-bold  `}
                      >
                        <div
                          className={`w-32 h-8 px-3 py-1.5 ${getOverallHealthColor(
                            data?.projectOverAllSituation
                          )} rounded justify-center items-center gap-px inline-flex`}
                        >
                          <div className=" text-xs font-medium leading-tight">
                            {t(data?.projectOverAllSituation)}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="statusImage -z-10 text-right ">
                      <img
                        className="h-full w-full select-none absolute top-5 right-0 transform -translate-x-0 -translate-y-6 "
                        src={`${data?.projectOverAllSituation ===
                            OverAllTrackEnumValue.SUNNY
                            ? Sunny
                            : data?.projectOverAllSituation ===
                              OverAllTrackEnumValue.CLOUDY
                              ? Cloudy
                              : data?.projectOverAllSituation ===
                                OverAllTrackEnumValue.RAINY
                                ? Rainy
                                : data?.projectOverAllSituation ===
                                  OverAllTrackEnumValue.STORMY
                                  ? Stormy
                                  : ""
                          }`}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="statsbox w-full h-fit flex flex-col lg:flex-row justify-between items-center gap-8  py-2 ">
                <div
                  className={`items-start relative flex-col bg-primary-400 #53C5B7 ${selectedStatusTheme?.colors.tabTexts}  rounded-2xl w-full h-full justify-center px-6 py-3 flex gap-5 backdrop-filter cursor-pointer`}
                >
                  <div className="text-lg ">{t("num_of_team_members")}</div>
                  <div className="text-4xl font-semibold">
                    {data.numTeamMembersWorkingOnTasks}
                  </div>
                  <img
                    className=" absolute right-2 bottom-2 h-6 w-6 opacity-70 hover:opacity-100 cursor-pointer" // onClick={() => filterRoutes(labelData)}
                    src={LinkArrow}
                    onClick={() => filterRoutes("Members")}
                  />
                </div>

                <div
                  className={`items-start relative flex-col ${selectedStatusTheme?.colors.tabTexts} bg-[#4DA8EF]  rounded-2xl w-full h-full justify-center px-6 py-3 flex gap-5 backdrop-filter cursor-pointer  ${selectedStatusTheme?.colors.tabBorders} `}
                >
                  <div className="text-lg ">{t("num_of_tasks")}</div>
                  <div className="text-4xl font-semibold">{data.numTasks}</div>
                  <img
                    className=" absolute right-2 bottom-2 h-6 w-6 opacity-70 hover:opacity-100 cursor-pointer"
                    onClick={() => filterRoutes("Tasks")}
                    src={LinkArrow}
                  />
                </div>
                <div
                  className={`items-start relative flex-col ${selectedStatusTheme?.colors.tabTexts} bg-[#9A7AE8] rounded-2xl w-full h-full justify-center px-6 py-3 flex gap-5 backdrop-filter cursor-pointer `}
                >
                  <div className="text-lg ">{t("num_of_milestones")}</div>
                  <div className="text-4xl font-semibold">
                    {data.numMilestones}
                  </div>
                  <img
                    className=" absolute right-2 bottom-2 h-6 w-6 opacity-70 hover:opacity-100 cursor-pointer"
                    onClick={() => filterRoutes("Milestones")}
                    src={LinkArrow}
                  />
                </div>
              </div>

              <div className="flex gap-2 items-start w-full">
                <div className="w-1/2">
                  <div className="font-bold text-2xl leading-normal text-gray-600/50 mb-4">
                    {t("project_schedule")}
                  </div>
                  <div className="flex gap-2 w-full  h-full">
                    <div className="w-full   flex flex-col gap-3 border-2 border-gray-500 rounded-2xl p-3 relative">
                      <div className="h-full flex flex-col gap-4 justify-between items-start">
                        <div className="w-full">{t("schedule_trend")}</div>
                        <div className="w-full text-gray-500 ">
                          <img
                            className="min-w-8"
                            src={
                              data?.scheduleTrend ===
                                ScheduleAndBudgetTrend.STABLE
                                ? Stable
                                : data?.scheduleTrend ===
                                  ScheduleAndBudgetTrend.INCREASING
                                  ? Increasing
                                  : data?.scheduleTrend ===
                                    ScheduleAndBudgetTrend.DECREASING
                                    ? Decreasing
                                    : ""
                            }
                          ></img>
                        </div>
                      </div>
                    </div>
                    <div
                      key={cpiComponent.current?.offsetHeight}
                      className={`w-full   justify-between flex flex-col gap-6 min-h-[7.3rem]  border-2 text-white border-gray-500 rounded-2xl p-3 relative ${Number(getSPI()) == 0
                          ? "bg-gray-450"
                          : Number(getSPI()) < 80
                            ? "bg-flag-red"
                            : Number(getSPI()) >= 80 && Number(getSPI()) < 95
                              ? "bg-flag-orange"
                              : Number(getSPI()) <= 100 && Number(getSPI()) >= 95
                                ? "bg-flag-green"
                                : "bg-flag-green"
                        }`}
                    >
                      <div className="w-full  text-base  pt-2">
                        {t("schedule_performance_index")}
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                              <img
                                src={InfoCircle}
                                className="h-[16px] w-[16px] invert brightness-0"
                                alt="InfoCircle"
                              />
                            </TooltipTrigger>
                            <TooltipContent>
                              <p className="text-sm text-center w-96">
                                {t("spi_tooltip")}
                                <hr className="h-px my-2 bg-gray-200 border-0 " />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: t("SPI_formula"),
                                  }}
                                ></div>
                              </p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </div>
                      <div className="flex gap-2 items-center">
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger>
                              <div className={`w-fit`}>
                                {Number(getSPI())?.toFixed(0)}%
                              </div>
                            </TooltipTrigger>
                            <TooltipContent>
                              <p className="text-sm text-center ">
                                {getSPI()}%
                              </p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                        {
                          <div className="text-xs">
                            {Number(getSPI()) == 0 ? (
                              <>
                                {t(
                                  "To have an up to date SPI, please update the tasks' progress"
                                )}
                                <Link
                                  to={`/tasks/${projectId}?view=LIST`}
                                  className="text-primary-400 underline ml-1"
                                >
                                  {t("spi_link")}
                                </Link>{" "}
                              </>
                            ) : Number(getSPI()) < 80 ? (
                              t("Project is significantly behind the schedule")
                            ) : Number(getSPI()) >= 80 &&
                              Number(getSPI()) < 95 ? (
                              t("Project is moderately behind schedule")
                            ) : Number(getSPI()) <= 100 &&
                              Number(getSPI()) >= 95 ? (
                              t("Project is on track")
                            ) : Number(getSPI()) > 100 ? (
                              t("Project is ahead of the schedule")
                            ) : (
                              ""
                            )}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-1/2  ">
                  <div className="font-bold text-2xl leading-normal text-gray-600/50 mb-4">
                    {t("project_budget")}
                  </div>
                  <div className="flex gap-2 w-full  h-full">
                    <div className="w-full   flex flex-col gap-3 border-2 border-gray-500 rounded-2xl p-3 relative">
                      <div className=" flex flex-col gap-3 justify-start items-start">
                        <div className="w-full ">{t("budget_trend")}</div>
                        <div className="w-fit h-full text-lg md:text-xl font-bold text-gray-500 text-center">
                          <img
                            className="min-w-10"
                            src={
                              data?.budgetTrend ===
                                ScheduleAndBudgetTrend.STABLE
                                ? Stable
                                : data?.budgetTrend ===
                                  ScheduleAndBudgetTrend.INCREASING
                                  ? Increasing
                                  : data?.budgetTrend ===
                                    ScheduleAndBudgetTrend.DECREASING
                                    ? Decreasing
                                    : ""
                            }
                          ></img>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`w-full  justify-between flex flex-col gap-6 min-h-[7.3rem] border-2 text-white border-gray-500 rounded-2xl p-3 relative ${Number(data.cpi) == 0
                          ? "bg-gray-450"
                          : Number(data.cpi) < 80
                            ? "bg-flag-red"
                            : Number(data.cpi) >= 80 && Number(data.cpi) < 95
                              ? "bg-flag-orange"
                              : Number(data.cpi) <= 100 && Number(data.cpi) >= 95
                                ? "bg-flag-green"
                                : Number(data.cpi) > 100
                                  ? "bg-flag-green"
                                  : ""
                        }`}
                    >
                      <div className="w-full pt-2 text-white">
                        {t("cost_performance_index")}
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                              <img
                                src={InfoCircle}
                                className="h-[16px] w-[16px] invert brightness-0"
                                alt="InfoCircle"
                              />
                            </TooltipTrigger>
                            <TooltipContent>
                              <p className="text-sm text-center w-96">
                                {" "}
                                {t("CPI_description")}
                                <hr className="h-px my-2 bg-gray-200 border-0 " />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: t("CPI_formula"),
                                  }}
                                ></div>
                              </p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                      </div>
                      <div className="flex items-center gap-2">
                        <TooltipProvider>
                          <Tooltip>
                            <TooltipTrigger className="">
                              <div className={`w-fit text-white`}>
                                {Number(data.cpi)?.toFixed()}%
                              </div>
                            </TooltipTrigger>
                            <TooltipContent>
                              <p className="text-sm text-center ">
                                {Number(data.cpi)?.toFixed(4)}%
                              </p>
                            </TooltipContent>
                          </Tooltip>
                        </TooltipProvider>
                        {
                          <div className="text-xs">
                            {Number(data.cpi) == 0 ? (
                              <>
                                {t(
                                  "To have an up to date CPI, please update the estimated budget and consumed budget in Project Settings"
                                )}
                                <Link
                                  to={`/project-details/${projectId}`}
                                  className="text-primary-400 underline ml-1"
                                >
                                  {t("cpi_link")}
                                </Link>{" "}
                              </>
                            ) : Number(data.cpi) < 80 ? (
                              t("Project is significantly over budget")
                            ) : Number(data.cpi) >= 80 &&
                              Number(data.cpi) < 95 ? (
                              t("Project is moderately over budget")
                            ) : Number(data.cpi) <= 100 && Number(data.cpi) > 95 ? (
                              t("Project is within budget")
                            ) : Number(data.cpi) > 100 ? (
                              t("Project is under budget")
                            ) : (
                              ""
                            )}
                          </div>
                        }
                        <div>
                          {/* (project is {Number(data.cpi)?.toFixed() - 100} behind schedule) */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex gap-2 ">
                <div className="mb-6 flex flex-col w-full">
                  <div className="w-full  h-fit overflow-auto">
                    <div className="h-full w-full text-left">
                      <div className="flex items-center">
                        <div className="p-2 w-1/2 bg-primary-100/85 rounded-tl-xl ">
                          {t("estimated_start_date")}
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-tr-xl">
                          {data?.projectDates?.startDate
                            ? dateFormatter(
                              new Date(data?.projectDates?.startDate)
                            )
                            : "N/A"}
                        </div>
                      </div>
                      <div className=" flex items-center">
                        <div className="p-2 w-1/2 bg-primary-100/85 relative">
                          {t("estimated_end_date")}
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm">
                                  {t("estimated_end_date_tooltip")}
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25">
                          {data?.projectDates?.estimatedEndDate
                            ? dateFormatter(
                              new Date(data?.projectDates?.estimatedEndDate)
                            )
                            : "N/A"}
                        </div>
                      </div>
                      <div className=" flex items-center">
                        <div className="p-2 w-1/2 bg-primary-100/85 rounded-bl-xl relative">
                          {t("estimated_duration")}
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm">
                                  {t("estimated_duration_tooltip")}
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-br-xl">
                          {data?.projectDates?.estimatedDuration ?? 0}{" "}
                          {t("Days")}
                        </div>
                      </div>
                      <div className="flex mt-2 items-center">
                        <div className="p-2  w-1/2 relative bg-primary-100/85 rounded-tl-xl ">
                          {t("actual_start_date")}
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm">
                                  {t("actual_start_date_tooltip")}
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-tr-xl">
                          {data?.projectDates?.actualStartDate
                            ? dateFormatter(
                              new Date(data?.projectDates?.actualStartDate)
                            )
                            : "N/A"}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="p-2  w-1/2 relative bg-primary-100/85 ">
                          {t("actual_end_date")}
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm">
                                  {t("actual_end_date_tooltip")}
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 ">
                          {data?.projectDates?.actualEndDate
                            ? dateFormatter(
                              new Date(data?.projectDates?.actualEndDate)
                            )
                            : "N/A"}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="p-2  w-1/2 relative bg-primary-100/85 rounded-bl-xl ">
                          {t("actual_duration")}
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm">
                                  {t("actual_duration_tooltip")}
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-br-xl">
                          {data?.projectDates?.actualDuration ?? 0} Days
                        </div>
                      </div>
                      <div className="flex  mt-2 items-center">
                        <div className="p-2 w-1/2 relative bg-[#0D062D] text-white rounded-tl-xl ">
                          {t("Re_calculated_end_date")}
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0 invert"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm">
                                  {t("Re_calculated_end_date_tooltip")}
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-tr-xl">
                          {data.keyPerformanceIndicator?.reCalculateEndDate
                            ? dateFormater(
                              new Date(
                                data.keyPerformanceIndicator?.reCalculateEndDate
                              )
                            )
                            : "N/A"}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="p-2 w-1/2 bg-[#0D062D] text-white rounded-bl-xl relative">
                          {t("Re_calculated_duration")}{" "}
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0 invert"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm w-96">
                                  {t("Re_calculated_duration_tooltip")}
                                </p>
                                <hr className="h-px my-2 bg-gray-200 border-0 " />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: t(
                                      "Re_calculated_duration_tooltip_formula"
                                    ),
                                  }}
                                ></div>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25  rounded-br-xl">
                          {data.keyPerformanceIndicator?.reCalculatedDuration?.toFixed(
                            0
                          ) ?? 0}{" "}
                          {t("Days")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-6 flex flex-col w-full">
                  <div className="w-full h-full overflow-x-auto">
                    <div className="h-full w-full text-left">
                      <div className=" flex items-center">
                        <div className="p-2  w-1/2 bg-primary-100/85 rounded-tl-xl">
                          {t("Currency")}
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-tr-xl">
                          {data.currency}
                        </div>
                      </div>
                      <div className=" flex items-center">
                        <div className="p-2  w-1/2 bg-primary-100/85">
                          {t("estimated_project_budget")}
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25">
                          {data?.estimatedBudget
                            ? data?.estimatedBudget
                            : "N/A"}
                        </div>
                      </div>
                      <div className=" flex items-center">
                        <div className="p-2  w-1/2 bg-primary-100/85 relative rounded-bl-xl">
                          <div className="max-w-[90%] truncate">
                            {t("consumed_project_budget")}
                          </div>
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm">
                                  {t("consumed_project_budget_tooltip")}
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-br-xl">
                          {data?.consumedBudget ? data?.consumedBudget : "N/A"}
                        </div>
                      </div>
                      <div className=" flex items-center mt-2">
                        <div className="p-2  w-1/2 bg-[#0D062D] text-white relative rounded-tl-xl  ">
                          <div className="max-w-[90%] truncate">
                            {t("Re-calculated_Budget")}
                          </div>
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger className="flex gap-1 mr-3 items-center absolute top-2 right-0">
                                <img
                                  src={InfoCircle}
                                  className="h-[16px] w-[16px] brightness-0 invert"
                                  alt="InfoCircle"
                                />
                              </TooltipTrigger>
                              <TooltipContent>
                                <p className="text-sm w-96 flex  flex-col">
                                  {t("calculated_budget_tooltip")}
                                  <hr className="h-px my-2 bg-gray-200 border-0 " />
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: t("Re_calculated_Budget_formula"),
                                    }}
                                  />
                                </p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-tr-xl">
                          {data &&
                            data.keyPerformanceIndicator?.reCalculateBudget &&
                            Number(
                              data.keyPerformanceIndicator?.reCalculateBudget
                            )
                            ? Number(
                              data.keyPerformanceIndicator.reCalculateBudget
                            )?.toFixed(0)
                            : "N/A"}
                        </div>
                      </div>
                      <div className="  flex items-center">
                        <div className="p-2 w-1/2   bg-[#0D062D] text-white rounded-bl-xl">
                          {t("budget_variation")}
                        </div>
                        <div className="p-2 w-1/2 bg-gray-450/25 rounded-br-xl">
                          {data.keyPerformanceIndicator?.budgetVariation?.toFixed(
                            0
                          ) ?? "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="">
                <div className="font-bold text-2xl leading-normal text-gray-600/50">
                  {t("tasks_indicators")}
                </div>
                <div className="taskCharts w-full h-fit flex flex-col md:flex-row justify-center items-center gap-6 py-2 ">
                  <div
                    className={`${selectedStatusTheme?.colors.chartGradient} ${selectedStatusTheme?.colors.chartBorders} rounded-2xl w-full md:w-1/2 h-[25rem] justify-center items-center flex gap-2 `}
                  >
                    {barChartProp ? (
                      <PieChart chartProps={barChartProp} />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className={` ${selectedStatusTheme?.colors.chartGradient} ${selectedStatusTheme?.colors.chartBorders} rounded-2xl w-full md:w-1/2 h-[25rem] justify-center items-center flex gap-2  `}
                  >
                    {statusPieChartProp ? (
                      <PieChart chartProps={statusPieChartProp} />
                    ) : (
                      <></>
                    )}
                  </div>
                  {/* <div className="risks rounded-2xl w-3/4 lg:w-1/4 h-full justify-center items-center  flex gap-2 backdrop-filter backdrop-blur-md bg-opacity-60 border border-gray-300">
<HorizontalBarChart chartProps={} />
</div> */}
                </div>
              </div>
              <div className="mt-3">
                <div className="font-bold text-2xl leading-normal text-gray-600/50 mb-2">
                  {t("risk matrix")}
                </div>
                <RiskMatrixTable
                  risks={riskMatrix}
                  onClick={function (data: RiskType): void {
                    open(data);
                  }}
                  projectId={projectId ?? ""}
                />
              </div>
            </div>
          </>
        )
      )}
    </>
  );
}
export default ProjectDashboard;
